import store from "@/store/";
import inscriptionService from "@/services/inscriptionService";
import {i18n} from "@/locales/index.js";
import contractModule from '@/store/modules/contract/index';
import router from '@/router';

export default async ({from, to, next}) => {
  if (to.params.id !== undefined && to.params.guid !== undefined) {
    console.log('middleware - addContract');
    let sub = await inscriptionService.getSubscription(to.params.id, to.params.guid);
    await store.dispatch("subscription/setSubscription", sub)

    // if(sub.lead_id) {
    //   let lead = await leadService.get(sub.lead_id);
    //   await store.dispatch(`consumption/setConsumption`, lead);
    // }
    // Remember old contract for datalayer
    if (!from.path.startsWith(`/${i18n.locale}/situation/personal-details`)) {
      let indiceOfCurrContract = findContractIndiceByID(store.state["contract"].id, sub)
      registerAndSet(sub.contracts[indiceOfCurrContract])
      //Check if we have an unvalid contract to update
      let i = 0;
      let foundUnValid = false;

      for (i; i < sub.contracts.length; ++i) {
        if (!sub.contracts[i].status.is_valid) {
          foundUnValid = true;
          break;
        }
      }

      // No unvalid contract found so we must add a new one
      if (!foundUnValid) {
        await store.commit("common/setLeadUuid", null);
        await store.commit("consumption/reset");
        await store.commit("contract/reset");

        let contract = await store.dispatch("contract/createContract");
        contract["address"] = sub.contracts[0].address;

        await store.dispatch("contract/setContract", contract)

        if (sub.agent) {
          let electricity = sub.contracts[0].electricity;
          let gas = sub.contracts[0].gas;
          let elecProduct = electricity ? electricity.product : null;
          let gasProduct = gas ? gas.product : null;

          let payload = {}

          if (gas && gas.agent_custom_id) {
            payload["elec_custom_id"] = gas.agent_custom_id;
            payload["gas_custom_id"] = gas.agent_custom_id;
          }

          if (electricity && electricity.agent_custom_id) {
            payload["elec_custom_id"] = electricity.agent_custom_id;
            payload["gas_custom_id"] = electricity.agent_custom_id;
          }

          if ((elecProduct && elecProduct.is_forced) || (gasProduct && gasProduct.is_forced)) {
            await store.dispatch("contract/setProductWithContract", sub.contracts[0]);

            if (elecProduct) {
              payload["elec_product_id"] = elecProduct.id;
              payload["elec_is_forced_product"] = 1;
              payload["elec_contract_type"] = electricity.contractType;
              console.log(electricity.duration)
              payload["elec_duration"] = electricity.duration;
            }

            if (gasProduct) {
              payload["gas_product_id"] = gasProduct.id;
              payload["gas_is_forced_product"] = 1;
              payload["gas_contract_type"] = gas.contractType;
              payload["gas_duration"] = gas.duration;
            }
          }

          if (Object.keys(payload).length)
            await inscriptionService.updateContract(contract.id, payload);
        }
        // We need to update the non valid contract
      } else {
        await store.dispatch(`contract/setContract`, sub.contracts[i]);
        await store.dispatch(`contract/setProductWithContract`, sub.contracts[i]);
      }
      return next(`/${i18n.locale}/situation/personal-details`);
      // We went back from personal-details so we must return to prev contract
    } else {
      let indiceOfPrevContract = sub.contracts.length - 2;
      //Register current contract
      registerAndSet(sub.contracts[sub.contracts.length - 1])

      //Set contract back to previous contract
      await store.dispatch(`contract/setContract`, sub.contracts[indiceOfPrevContract])
      await store.dispatch(`contract/setProductWithContract`, sub.contracts[indiceOfPrevContract])

      //router.replace(`/${i18n.locale}/payment`);
      //return next(`/${i18n.locale}/payment`);
      router.go(-1);
    }

    return next();
  }
}

async function registerAndSet(contract){
  if (!store.hasModule(`contract_${contract.id}`))
    store.registerModule(`contract_${contract.id}`, contractModule);
  await store.dispatch(`contract_${contract.id}/setContract`, contract);
  await store.dispatch(`contract_${contract.id}/setProductWithContract`, contract);
}

function findContractIndiceByID(contractID ,sub){
  for(const contract in sub.contracts){
    if(sub.contracts[contract].id == contractID)
      return contract;
  }
}



// WEBPACK FOOTER //
// ./src/router/middleware/addContract.js